import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'parsleyjs';
import $ from 'jquery';
import { loginUser } from '../../api/auth';

const Login = (props) => {

    $(function() {
        document.title = "Sign In";
        $(function () {
            $('#login').parsley();
        });

        return () => {
            $('#login').parsley().destroy();
        }
    });

    const dispatch = useDispatch();

    //Selector
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [stateReady, setStateReady] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const result = {
            email: $('#email').val(),
            password: $('#password').val(),
        };

        setStateReady(true);
        dispatch(loginUser(result)).then(() => {
            setStateReady(false);
        });
    };

    if(isAuthenticated) {
        props.history.push('/dashboard');
    }

    return (
        <div id="login-content">
            <div className="container login-container">
                <img src="assets/img/logo-cr.png" className="logo mb-5" alt="logo" />
                <div className="card">
                    <h2 className="mt-2">Log in to continue</h2>
                    <p>Connect every social account and stay in control from a single dashboard.</p>
                    <form id="login" className="parsley-style-1" data-parsley-validate="true" onSubmit={handleSubmit.bind()}>
                        <div id="emailWrapper" className="form-group parsley-input mb-3">
                            <label>Email address</label>
                            <input id="email" type="email" className="form-control"
                                   placeholder="Enter your email address"
                                   autoComplete="off"
                                   data-parsley-class-handler="#emailWrapper" required/>
                        </div>
                        <div id="passwordWrapper" className="form-group parsley-input">
                            <div className="mg-b-5">
                                <label className="mg-b-0-f">Password</label>
                            </div>
                            <input id="password" type="password" className="form-control"
                                   placeholder="Enter your password"
                                   data-parsley-minlength="6"
                                   autoComplete="off"
                                   data-parsley-class-handler="#passwordWrapper" required/>
                        </div>
                        <div className="d-grid mt-4">
                            {stateReady ? <button className="btn btn-secondary btn-block" disabled><span className="spinner-border spinner-border-sm" style={{marginRight: 5}} role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary">Continue</button>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
};

export default Login;
